import { setPagination } from '../State/pagination';
import fetchSubcontractors from '../Services/fetchSubcontractors';

export default () => async (dispatch) => {

  dispatch(setPagination({ current: 1 }));

  dispatch(fetchSubcontractors());
  
}